var cookieconsent = (function (e) {
    var t = {};
    function i(n) {
        if (t[n]) return t[n].exports;
        var o = (t[n] = { i: n, l: !1, exports: {} });
        return e[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
    }
    return (
        (i.m = e),
        (i.c = t),
        (i.d = function (e, t, n) {
            i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
        }),
        (i.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (i.t = function (e, t) {
            if ((1 & t && (e = i(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if ((i.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var o in e)
                    i.d(
                        n,
                        o,
                        function (t) {
                            return e[t];
                        }.bind(null, o)
                    );
            return n;
        }),
        (i.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return i.d(t, "a", t), t;
        }),
        (i.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (i.p = ""),
        i((i.s = 53))
    );
})([
    function (e, t, i) {
        "use strict";
        e.exports = function (e) {
            var t = [];
            return (
                (t.toString = function () {
                    return this.map(function (t) {
                        var i = (function (e, t) {
                            var i = e[1] || "",
                                n = e[3];
                            if (!n) return i;
                            if (t && "function" == typeof btoa) {
                                var o = ((s = n), "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(s)))) + " */"),
                                    a = n.sources.map(function (e) {
                                        return "/*# sourceURL=" + n.sourceRoot + e + " */";
                                    });
                                return [i].concat(a).concat([o]).join("\n");
                            }
                            var s;
                            return [i].join("\n");
                        })(t, e);
                        return t[2] ? "@media " + t[2] + "{" + i + "}" : i;
                    }).join("");
                }),
                (t.i = function (e, i) {
                    "string" == typeof e && (e = [[null, e, ""]]);
                    for (var n = {}, o = 0; o < this.length; o++) {
                        var a = this[o][0];
                        null != a && (n[a] = !0);
                    }
                    for (o = 0; o < e.length; o++) {
                        var s = e[o];
                        (null != s[0] && n[s[0]]) || (i && !s[2] ? (s[2] = i) : i && (s[2] = "(" + s[2] + ") and (" + i + ")"), t.push(s));
                    }
                }),
                t
            );
        };
    },
    function (e, t, i) {
        var n,
            o,
            a = {},
            s =
                ((n = function () {
                    return window && document && document.all && !window.atob;
                }),
                function () {
                    return void 0 === o && (o = n.apply(this, arguments)), o;
                }),
            r = function (e, t) {
                return t ? t.querySelector(e) : document.querySelector(e);
            },
            c = (function (e) {
                var t = {};
                return function (e, i) {
                    if ("function" == typeof e) return e();
                    if (void 0 === t[e]) {
                        var n = r.call(this, e, i);
                        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement)
                            try {
                                n = n.contentDocument.head;
                            } catch (e) {
                                n = null;
                            }
                        t[e] = n;
                    }
                    return t[e];
                };
            })(),
            l = null,
            p = 0,
            d = [],
            u = i(40);
        function _(e, t) {
            for (var i = 0; i < e.length; i++) {
                var n = e[i],
                    o = a[n.id];
                if (o) {
                    o.refs++;
                    for (var s = 0; s < o.parts.length; s++) o.parts[s](n.parts[s]);
                    for (; s < n.parts.length; s++) o.parts.push(g(n.parts[s], t));
                } else {
                    var r = [];
                    for (s = 0; s < n.parts.length; s++) r.push(g(n.parts[s], t));
                    a[n.id] = { id: n.id, refs: 1, parts: r };
                }
            }
        }
        function m(e, t) {
            for (var i = [], n = {}, o = 0; o < e.length; o++) {
                var a = e[o],
                    s = t.base ? a[0] + t.base : a[0],
                    r = { css: a[1], media: a[2], sourceMap: a[3] };
                n[s] ? n[s].parts.push(r) : i.push((n[s] = { id: s, parts: [r] }));
            }
            return i;
        }
        function k(e, t) {
            var i = c(e.insertInto);
            if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
            var n = d[d.length - 1];
            if ("top" === e.insertAt) n ? (n.nextSibling ? i.insertBefore(t, n.nextSibling) : i.appendChild(t)) : i.insertBefore(t, i.firstChild), d.push(t);
            else if ("bottom" === e.insertAt) i.appendChild(t);
            else {
                if ("object" != typeof e.insertAt || !e.insertAt.before)
                    throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
                var o = c(e.insertAt.before, i);
                i.insertBefore(t, o);
            }
        }
        function v(e) {
            if (null === e.parentNode) return !1;
            e.parentNode.removeChild(e);
            var t = d.indexOf(e);
            t >= 0 && d.splice(t, 1);
        }
        function f(e) {
            var t = document.createElement("style");
            if ((void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce)) {
                var n = (function () {
                    0;
                    return i.nc;
                })();
                n && (e.attrs.nonce = n);
            }
            return b(t, e.attrs), k(e, t), t;
        }
        function b(e, t) {
            Object.keys(t).forEach(function (i) {
                e.setAttribute(i, t[i]);
            });
        }
        function g(e, t) {
            var i, n, o, a;
            if (t.transform && e.css) {
                if (!(a = "function" == typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
                e.css = a;
            }
            if (t.singleton) {
                var s = p++;
                (i = l || (l = f(t))), (n = x.bind(null, i, s, !1)), (o = x.bind(null, i, s, !0));
            } else
                e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa
                    ? ((i = (function (e) {
                          var t = document.createElement("link");
                          return void 0 === e.attrs.type && (e.attrs.type = "text/css"), (e.attrs.rel = "stylesheet"), b(t, e.attrs), k(e, t), t;
                      })(t)),
                      (n = z.bind(null, i, t)),
                      (o = function () {
                          v(i), i.href && URL.revokeObjectURL(i.href);
                      }))
                    : ((i = f(t)),
                      (n = w.bind(null, i)),
                      (o = function () {
                          v(i);
                      }));
            return (
                n(e),
                function (t) {
                    if (t) {
                        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
                        n((e = t));
                    } else o();
                }
            );
        }
        e.exports = function (e, t) {
            if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
            ((t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}), t.singleton || "boolean" == typeof t.singleton || (t.singleton = s()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
            var i = m(e, t);
            return (
                _(i, t),
                function (e) {
                    for (var n = [], o = 0; o < i.length; o++) {
                        var s = i[o];
                        (r = a[s.id]).refs--, n.push(r);
                    }
                    e && _(m(e, t), t);
                    for (o = 0; o < n.length; o++) {
                        var r;
                        if (0 === (r = n[o]).refs) {
                            for (var c = 0; c < r.parts.length; c++) r.parts[c]();
                            delete a[r.id];
                        }
                    }
                }
            );
        };
        var h,
            y =
                ((h = []),
                function (e, t) {
                    return (h[e] = t), h.filter(Boolean).join("\n");
                });
        function x(e, t, i, n) {
            var o = i ? "" : n.css;
            if (e.styleSheet) e.styleSheet.cssText = y(t, o);
            else {
                var a = document.createTextNode(o),
                    s = e.childNodes;
                s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(a, s[t]) : e.appendChild(a);
            }
        }
        function w(e, t) {
            var i = t.css,
                n = t.media;
            if ((n && e.setAttribute("media", n), e.styleSheet)) e.styleSheet.cssText = i;
            else {
                for (; e.firstChild; ) e.removeChild(e.firstChild);
                e.appendChild(document.createTextNode(i));
            }
        }
        function z(e, t, i) {
            var n = i.css,
                o = i.sourceMap,
                a = void 0 === t.convertToAbsoluteUrls && o;
            (t.convertToAbsoluteUrls || a) && (n = u(n)), o && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
            var s = new Blob([n], { type: "text/css" }),
                r = e.href;
            (e.href = URL.createObjectURL(s)), r && URL.revokeObjectURL(r);
        }
    },
    function (e) {
        e.exports = JSON.parse(
            '{"i18n":{"active":"Active","always_active":"Always active","impressum":"<a href=\'%s\' target=\'_blank\'>Impressum</a>","inactive":"Inactive","nb_agree":"I agree","nb_changep":"Change my preferences","nb_ok":"OK","nb_reject":"I decline","nb_text":"We use cookies and other tracking technologies to improve your browsing experience on our website, to show you personalized content and targeted ads, to analyze our website traffic, and to understand where our visitors are coming from.","nb_title":"We use cookies","pc_fnct_text_1":"Functionality cookies","pc_fnct_text_2":"These cookies are used to provide you with a more personalized experience on our website and to remember choices you make when you use our website.","pc_fnct_text_3":"For example, we may use functionality cookies to remember your language preferences or remember your login details.","pc_minfo_text_1":"More information","pc_minfo_text_2":"For any queries in relation to our policy on cookies and your choices, please contact us.","pc_minfo_text_3":"To find out more, please visit our <a href=\'%s\' target=\'_blank\'>Privacy Policy</a>.","pc_save":"Save my preferences","pc_sncssr_text_1":"Strictly necessary cookies","pc_sncssr_text_2":"These cookies are essential to provide you with services available through our website and to enable you to use certain features of our website.","pc_sncssr_text_3":"Without these cookies, we cannot provide you certain services on our website.","pc_title":"Cookies Preferences Center","pc_trck_text_1":"Tracking cookies","pc_trck_text_2":"These cookies are used to collect information to analyze the traffic to our website and how visitors are using our website.","pc_trck_text_3":"For example, these cookies may track things such as how long you spend on the website or the pages you visit which helps us to understand how we can improve our website for you.","pc_trck_text_4":"The information collected through these tracking and performance cookies do not identify any individual visitor.","pc_trgt_text_1":"Targeting and advertising cookies","pc_trgt_text_2":"These cookies are used to show advertising that is likely to be of interest to you based on your browsing habits.","pc_trgt_text_3":"These cookies, as served by our content and/or advertising providers, may combine information they collected from our website with other information they have independently collected relating to your web browser\'s activities across their network of websites.","pc_trgt_text_4":"If you choose to remove or disable these targeting or advertising cookies, you will still see adverts but they may not be relevant to you.","pc_yprivacy_text_1":"Your privacy is important to us","pc_yprivacy_text_2":"Cookies are very small text files that are stored on your computer when you visit a website. We use cookies for a variety of purposes and to enhance your online experience on our website (for example, to remember your account login details).","pc_yprivacy_text_3":"You can change your preferences and decline certain types of cookies to be stored on your computer while browsing our website. You can also remove any cookies already stored on your computer, but keep in mind that deleting cookies may prevent you from using parts of our website.","pc_yprivacy_title":"Your privacy","privacy_policy":"<a href=\'%s\' target=\'_blank\'>Privacy Policy</a>"}}'
        );
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = JSON.parse(
            '{"i18n":{"active":"Aktywne","always_active":"Zawsze aktywne","impressum":"<a href=\'%s\' target=\'_blank\'>Impressum</a>","inactive":"Nieaktywne","nb_agree":"Zgoda","nb_changep":"Zmiana ustawień","nb_ok":"OK","nb_reject":"Odmawiam","nb_text":"Używamy plików cookie i innych technologii śledzenia, aby poprawić jakość przeglądania naszej witryny, wyświetlać spersonalizowane treści i reklamy, analizować ruch w naszej witrynie i wiedzieć, skąd pochodzą nasi użytkownicy.","nb_title":"Używamy plików cookie","pc_fnct_text_1":"Funkcjonalne","pc_fnct_text_2":"Te pliki cookie służą do bardziej spersonalizowanego korzystania z naszej strony internetowej i do zapamiętywania wyborów dokonywanych podczas korzystania z naszej strony internetowej.","pc_fnct_text_3":"Na przykład możemy używać funkcjonalnych plików cookie do zapamiętywania preferencji językowych lub zapamiętywania danych logowania.","pc_minfo_text_1":"Więcej informacji","pc_minfo_text_2":"W przypadku jakichkolwiek pytań dotyczących naszej polityki dotyczącej plików cookie i Twoich wyborów, skontaktuj się z nami.","pc_minfo_text_3":"Aby dowiedzieć się więcej, odwiedź naszą <a href=\'%s\' target=\'_blank\'>Polityka prywatności</a>.","pc_save":"Zapisz ustawienia","pc_sncssr_text_1":"Niezbędne","pc_sncssr_text_2":"Te pliki cookie są niezbędne do świadczenia usług dostępnych za pośrednictwem naszej strony internetowej i umożliwienia korzystania z niektórych funkcji naszej strony internetowej.","pc_sncssr_text_3":"Bez tych plików cookie nie możemy zapewnić usług na naszej stronie internetowej.","pc_title":"Centrum ustawień cookie","pc_trck_text_1":"Śledzenie i wydajność","pc_trck_text_2":"Te pliki cookie służą do zbierania informacji w celu analizy ruchu na naszej stronie internetowej i sposobu, w jaki użytkownicy korzystają z naszej strony internetowej.","pc_trck_text_3":"Na przykład te pliki cookie mogą śledzić takie rzeczy, jak czas spędzony na stronie lub odwiedzane strony, co pomaga nam zrozumieć, w jaki sposób możemy ulepszyć naszą witrynę internetową.","pc_trck_text_4":"Informacje zebrane przez te pliki nie identyfikują żadnego konkretnego użytkownika.","pc_trgt_text_1":"Targeting i reklama","pc_trgt_text_2":"Te pliki cookie służą do wyświetlania reklam, które mogą Cię zainteresować na podstawie Twoich zwyczajów przeglądania.","pc_trgt_text_3":"Pliki te tworzone przez naszych dostawców treści i/lub reklam, mogą łączyć informacje zebrane z naszej strony z innymi informacjami, które gromadzili niezależnie w związku z działaniami przeglądarki internetowej w ich sieci witryn.","pc_trgt_text_4":"Jeśli zdecydujesz się usunąć lub wyłączyć te pliki cookie, reklamy nadal będą wyświetlane, ale mogą one nie być odpowiednie dla Ciebie.","pc_yprivacy_text_1":"Twoja prywatność jest dla nas ważna","pc_yprivacy_text_2":"Pliki cookie to bardzo małe pliki tekstowe, które są tworzone i przechowywane na komputerze użytkownika podczas odwiedzania strony internetowej. Używamy plików cookie do różnych celów, w tym do ulepszania obsługi online na naszej stronie internetowej (na przykład, aby zapamiętać dane logowania do konta).","pc_yprivacy_text_3":"Możesz zmienić swoje ustawienia i odrzucić niektóre rodzaje plików cookie, które mają być przechowywane na twoim komputerze podczas przeglądania naszej strony. Możesz również usunąć wszystkie pliki cookie już zapisane na komputerze, ale pamiętaj, że usunięcie plików cookie może uniemożliwić korzystanie z części naszej strony internetowej.","pc_yprivacy_title":"Twoja prywatność","privacy_policy":"<a href=\'%s\' target=\'_blank\'>Polityka prywatności</a>"}}'
        );
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e) {
        e.exports = '';
    },
    function (e, t, i) {
        var n = i(39);
        "string" == typeof n && (n = [[e.i, n, ""]]);
        var o = { hmr: !0, transform: void 0, insertInto: void 0 };
        i(1)(n, o);
        n.locals && (e.exports = n.locals);
    },
    function (e, t, i) {
        (e.exports = i(0)(!1)).push([e.i, "", ""]);
    },
    function (e, t) {
        e.exports = function (e) {
            var t = "undefined" != typeof window && window.location;
            if (!t) throw new Error("fixUrls requires window.location");
            if (!e || "string" != typeof e) return e;
            var i = t.protocol + "//" + t.host,
                n = i + t.pathname.replace(/\/[^\/]*$/, "/");
            return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
                var o,
                    a = t
                        .trim()
                        .replace(/^"(.*)"$/, function (e, t) {
                            return t;
                        })
                        .replace(/^'(.*)'$/, function (e, t) {
                            return t;
                        });
                return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : ((o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? i + a : n + a.replace(/^\.\//, "")), "url(" + JSON.stringify(o) + ")");
            });
        };
    },
    function (e, t, i) {
        var n = i(42);
        "string" == typeof n && (n = [[e.i, n, ""]]);
        var o = { hmr: !0, transform: void 0, insertInto: void 0 };
        i(1)(n, o);
        n.locals && (e.exports = n.locals);
    },
    function (e, t, i) {
        (e.exports = i(0)(!1)).push([
            e.i,
            '.termsfeed-com---reset{-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0);margin:0;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}.termsfeed-com---reset *,.termsfeed-com---reset *::before,.termsfeed-com---reset *::after{box-sizing:border-box}.termsfeed-com---reset a,.termsfeed-com---reset li,.termsfeed-com---reset p,.termsfeed-com---reset h1,.termsfeed-com---reset h2,.termsfeed-com---reset input,.termsfeed-com---reset button,.termsfeed-com---reset select{border-style:none;box-shadow:none;margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;outline:none}@-ms-viewport{.termsfeed-com---reset{width:device-width}}.termsfeed-com---reset [tabindex="-1"]:focus{outline:0 !important}.termsfeed-com---reset h1,.termsfeed-com---reset h2,.termsfeed-com---reset h3,.termsfeed-com---reset h4,.termsfeed-com---reset h5,.termsfeed-com---reset h6{margin-top:0;margin-bottom:0;color:#000}.termsfeed-com---reset p{margin-top:0;margin-bottom:1rem}.termsfeed-com---reset div{display:block}.termsfeed-com---reset ol,.termsfeed-com---reset ul,.termsfeed-com---reset dl{margin-top:0;margin-bottom:1rem}.termsfeed-com---reset ol ol,.termsfeed-com---reset ul ul,.termsfeed-com---reset ol ul,.termsfeed-com---reset ul ol{margin-bottom:0}.termsfeed-com---reset b,.termsfeed-com---reset strong{font-weight:bolder}.termsfeed-com---reset small{font-size:80%}.termsfeed-com---reset a{color:#007bff;text-decoration:none;background-color:rgba(0,0,0,0);-webkit-text-decoration-skip:objects}.termsfeed-com---reset a:hover{color:#0056b3;text-decoration:underline}.termsfeed-com---reset a:not([href]):not([tabindex]){color:inherit;text-decoration:none}.termsfeed-com---reset a:not([href]):not([tabindex]):hover,.termsfeed-com---reset a:not([href]):not([tabindex]):focus{color:inherit;text-decoration:none}.termsfeed-com---reset a:not([href]):not([tabindex]):focus{outline:0}.termsfeed-com---reset label{display:inline-block;margin-bottom:.5rem}.termsfeed-com---reset button{border-radius:2px;padding:.5rem 1rem;outline:none;background:#dcdae5;color:#111;cursor:pointer;border:none}.termsfeed-com---reset button:focus{outline:none}.termsfeed-com---reset select{border-style:none;padding:.5rem 1rem}.termsfeed-com---reset input,.termsfeed-com---reset button,.termsfeed-com---reset select,.termsfeed-com---reset optgroup,.termsfeed-com---reset textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}.termsfeed-com---reset button,.termsfeed-com---reset input{overflow:visible}.termsfeed-com---reset button,.termsfeed-com---reset select{text-transform:none}.termsfeed-com---reset button,.termsfeed-com---reset html [type=button],.termsfeed-com---reset [type=reset],.termsfeed-com---reset [type=submit]{-webkit-appearance:button}.termsfeed-com---reset button::-moz-focus-inner,.termsfeed-com---reset [type=button]::-moz-focus-inner,.termsfeed-com---reset [type=reset]::-moz-focus-inner,.termsfeed-com---reset [type=submit]::-moz-focus-inner{padding:0;border-style:none}.termsfeed-com---reset input[type=radio],.termsfeed-com---reset input[type=checkbox]{box-sizing:border-box;padding:0}.termsfeed-com---reset [hidden]{display:none !important}',
            "",
        ]);
    },
    function (e, t, i) {
        var n = i(44);
        "string" == typeof n && (n = [[e.i, n, ""]]);
        var o = { hmr: !0, transform: void 0, insertInto: void 0 };
        i(1)(n, o);
        n.locals && (e.exports = n.locals);
    },
    function (e, t, i) {
        (e.exports = i(0)(!1)).push([
            e.i,
            '.termsfeed-com---nb{overflow:auto;z-index:99999999999;font-size:16px}.termsfeed-com---nb .cc-nb-main-container{padding:3rem}.termsfeed-com---nb .cc-nb-title{font-size:24px;font-weight:600}.termsfeed-com---nb .cc-nb-text{font-size:16px;margin:0 0 1.25rem 0}.termsfeed-com---nb .cc-nb-okagree,.termsfeed-com---nb .cc-nb-reject,.termsfeed-com---nb .cc-nb-changep{font-weight:bold;font-size:14px;margin-right:.25rem !important;margin-bottom:.25rem !important}@media(max-width: 480px){.termsfeed-com---nb .cc-nb-okagree,.termsfeed-com---nb .cc-nb-reject,.termsfeed-com---nb .cc-nb-changep{display:block;width:100%}}.termsfeed-com---nb-headline{right:0;top:auto;bottom:0;left:0;max-width:100%;position:relative}@media(max-width: 320px),(max-height: 480px){.termsfeed-com---nb-headline{overflow:auto;height:200px;max-width:100%;right:0;top:auto;bottom:0;left:auto;position:fixed}}.termsfeed-com---nb-simple{right:0;top:auto;bottom:0;left:auto;max-width:50%;position:fixed}@media screen and (max-width: 600px){.termsfeed-com---nb-simple{max-width:80%}}@media(max-width: 320px),(max-height: 480px){.termsfeed-com---nb-simple{overflow:auto;height:200px;max-width:100%}}.termsfeed-com---nb-interstitial-overlay{position:fixed;top:0;left:0;height:100%;width:100%;background:rgba(0,0,0,.8);z-index:9999999999}.termsfeed-com---nb-interstitial{right:3vw;top:3vh;left:3vw;max-width:100%;position:fixed}@media(max-width: 320px),(max-height: 480px){.termsfeed-com---nb-interstitial{overflow:auto;height:200px;right:0;top:auto;bottom:0;left:auto;position:fixed}}.termsfeed-com---nb-standalone{position:fixed;top:0;left:0;height:100%;width:100%}@media(max-width: 320px),(max-height: 480px){.termsfeed-com---nb-standalone{overflow:auto;height:200px;max-width:100%;right:0;top:auto;bottom:0;left:auto;position:fixed}}.termsfeed-com---pc-overlay{width:100%;height:100%;position:fixed;background:rgba(0,0,0,.5);z-index:999999999999;top:0;left:0;display:none}@media screen and (max-width: 600px){.termsfeed-com---pc-overlay{overflow-y:scroll}}.termsfeed-com---pc-dialog{position:absolute;margin:30px auto;width:750px;max-width:90%;height:auto;left:0;right:0}.termsfeed-com---pc-dialog>div{width:100%}.termsfeed-com---pc-dialog .cc-pc-container{width:100%;display:flex;background:#fff;flex-direction:column}.termsfeed-com---pc-dialog .cc-pc-head{background:#fff;color:#111;display:flex;flex-direction:row;justify-content:space-between}@media screen and (max-width: 600px){.termsfeed-com---pc-dialog .cc-pc-head{flex-direction:column}}.termsfeed-com---pc-dialog .cc-pc-head-title{display:flex;padding-left:15px;flex-direction:column;justify-content:center;align-items:baseline}@media screen and (max-width: 600px){.termsfeed-com---pc-dialog .cc-pc-head-title{align-items:center;padding:15px 0 0 0}}.termsfeed-com---pc-dialog .cc-pc-head-title-text{font-size:16px;line-height:1.5;margin:0}.termsfeed-com---pc-dialog .cc-pc-head-title-headline{font-size:20px;font-weight:600;margin:0}.termsfeed-com---pc-dialog .cc-pc-head-lang{display:flex;align-items:center;padding-right:15px;min-height:80px;justify-content:center;flex-direction:row-reverse}@media screen and (max-width: 600px){.termsfeed-com---pc-dialog .cc-pc-head-lang{padding:15px 0;min-height:20px}}.termsfeed-com---pc-dialog .cc-pc-head-close{display:flex;align-items:center;justify-content:center;margin-left:15px}.termsfeed-com---pc-dialog .cc-cp-body{display:flex;flex-direction:row;align-items:stretch;background:#292929;color:#f5f5f5;border-bottom:none}@media screen and (max-width: 600px){.termsfeed-com---pc-dialog .cc-cp-body{flex-direction:column}}.termsfeed-com---pc-dialog .cc-cp-body-tabs{font-family:Arial,sans-serif !important;width:150px;margin:0;padding:0;background:#e6e6e6;min-width:150px}@media screen and (max-width: 600px){.termsfeed-com---pc-dialog .cc-cp-body-tabs{width:100%}}.termsfeed-com---pc-dialog .cc-cp-body-tabs-item{margin:0;padding:0;float:left;display:block;width:100%;color:#666;background:#e6e6e6;border-bottom:1px solid #ccc;border-right:1px solid #ccc;transition:all ease .1s;box-sizing:content-box}@media screen and (max-width: 600px){.termsfeed-com---pc-dialog .cc-cp-body-tabs-item{border-right:0}}.termsfeed-com---pc-dialog .cc-cp-body-tabs-item[active=true]{background:#292929;color:#f5f5f5}.termsfeed-com---pc-dialog .cc-cp-body-tabs-item-link{text-decoration:none;color:#666;display:block;padding:10px 5px 10px 10px;font-weight:700;font-size:12px;line-height:19px;position:relative;cursor:pointer;width:100%;text-align:left;background:none;word-wrap:break-word;white-space:break-spaces}.termsfeed-com---pc-dialog .cc-cp-body-content{background:#292929;color:#f5f5f5}.termsfeed-com---pc-dialog .cc-cp-body-content-entry{width:100%;display:none;padding:25px;box-sizing:border-box}.termsfeed-com---pc-dialog .cc-cp-body-content-entry[active=true]{display:block}.termsfeed-com---pc-dialog .cc-cp-body-content-entry-title{font-size:24px;font-weight:600}.termsfeed-com---pc-dialog .cc-cp-body-content-entry-text{font-size:16px;line-height:1.5}.termsfeed-com---pc-dialog .cc-cp-foot{background:#f2f2f2;display:flex;flex-direction:row;align-items:center;border-top:1px solid #ccc;justify-content:space-between}.termsfeed-com---pc-dialog .cc-cp-foot-byline{padding:20px 10px;font-size:14px;color:#333;display:block !important}.termsfeed-com---pc-dialog .cc-cp-foot-byline a{color:#999}.termsfeed-com---pc-dialog .cc-cp-foot-save,.termsfeed-com---pc-dialog .cc-nb-reject{margin-right:10px;opacity:.9;transition:all ease .3s;font-size:14px;font-weight:bold;height:auto}.termsfeed-com---pc-dialog .cc-cp-foot-save:hover{opacity:1}.termsfeed-com---pc-dialog input[type=checkbox].cc-custom-checkbox{position:absolute;margin:2px 0 0 16px;cursor:pointer;appearance:none;border:0}.termsfeed-com---pc-dialog input[type=checkbox].cc-custom-checkbox+label{position:relative;padding:4px 0 0 50px;line-height:2em;cursor:pointer;display:inline;font-size:14px}.termsfeed-com---pc-dialog input[type=checkbox].cc-custom-checkbox+label:before{content:"";position:absolute;display:block;left:0;top:0;width:40px;height:24px;border-radius:16px;background:#fff;border:1px solid #d9d9d9;-webkit-transition:all .3s;transition:all .3s}.termsfeed-com---pc-dialog input[type=checkbox].cc-custom-checkbox+label:after{content:"";position:absolute;display:block;left:0px;top:0px;width:24px;height:24px;border-radius:16px;background:#fff;border:1px solid #d9d9d9;-webkit-transition:all .3s;transition:all .3s}.termsfeed-com---pc-dialog input[type=checkbox].cc-custom-checkbox+label:hover:after{box-shadow:0 0 5px rgba(0,0,0,.3)}.termsfeed-com---pc-dialog input[type=checkbox].cc-custom-checkbox:checked+label:after{margin-left:16px}.termsfeed-com---pc-dialog input[type=checkbox].cc-custom-checkbox:checked+label:before{background:#55d069}',
            "",
        ]);
    },
    function (e, t, i) {
        var n = i(46);
        "string" == typeof n && (n = [[e.i, n, ""]]);
        var o = { hmr: !0, transform: void 0, insertInto: void 0 };
        i(1)(n, o);
        n.locals && (e.exports = n.locals);
    },
    function (e, t, i) {
        (e.exports = i(0)(!1)).push([
            e.i,
            ".termsfeed-com---palette-dark.termsfeed-com---nb{background-color:#111;color:#fff}.termsfeed-com---palette-dark .cc-nb-title{color:#fff}.termsfeed-com---palette-dark .cc-nb-text{color:#fff}.termsfeed-com---palette-dark .cc-nb-text a{color:#fff;text-decoration:underline}.termsfeed-com---palette-dark .cc-nb-text a:hover{text-decoration:none}.termsfeed-com---palette-dark .cc-nb-text a:focus{box-shadow:0 0 0 2px #3dd000}.termsfeed-com---palette-dark .cc-nb-okagree{color:#000;background-color:#ff0}.termsfeed-com---palette-dark .cc-nb-okagree:focus{box-shadow:0 0 0 2px #3dd000}.termsfeed-com---palette-dark .cc-nb-reject{color:#000;background-color:#ff0}.termsfeed-com---palette-dark .cc-nb-reject:focus{box-shadow:0 0 0 2px #3dd000}.termsfeed-com---palette-dark .cc-nb-changep{background-color:#eaeaea;color:#111}.termsfeed-com---palette-dark .cc-nb-changep:focus{box-shadow:0 0 0 2px #3dd000}.termsfeed-com---palette-dark .cc-pc-container{background:#212121}.termsfeed-com---palette-dark .cc-pc-head{background:#212121;color:#fff;border-bottom:1px solid #111}.termsfeed-com---palette-dark .cc-pc-head-title-headline{color:#fff}.termsfeed-com---palette-dark .cc-pc-head-title-text{color:#fff}.termsfeed-com---palette-dark .cc-pc-head-lang select{color:#212121}.termsfeed-com---palette-dark .cc-pc-head-lang select:focus{box-shadow:0 0 0 2px #ff0}.termsfeed-com---palette-dark .cc-pc-head-close{background:none;color:#e6e6e6}.termsfeed-com---palette-dark .cc-pc-head-close:active,.termsfeed-com---palette-dark .cc-pc-head-close:focus{border:2px solid #ff0}.termsfeed-com---palette-dark .cc-cp-body{background:#292929 !important;color:#f5f5f5}.termsfeed-com---palette-dark .cc-cp-body-tabs{color:#666;background:#e6e6e6}.termsfeed-com---palette-dark .cc-cp-body-tabs-item{border-right-color:#ccc;border-bottom-color:#ccc}.termsfeed-com---palette-dark .cc-cp-body-tabs-item-link{color:#666}.termsfeed-com---palette-dark .cc-cp-body-tabs-item-link:hover{color:#666}.termsfeed-com---palette-dark .cc-cp-body-tabs-item-link:focus{box-shadow:0 0 0 2px #292929}.termsfeed-com---palette-dark .cc-cp-body-tabs-item[active=true]{background:#292929 !important}.termsfeed-com---palette-dark .cc-cp-body-tabs-item[active=true] button{color:#f5f5f5}.termsfeed-com---palette-dark .cc-cp-body-content{background:#292929 !important;color:#f5f5f5}.termsfeed-com---palette-dark .cc-cp-body-content-entry-title{color:#fff}.termsfeed-com---palette-dark .cc-cp-body-content-entry-text{color:#fff}.termsfeed-com---palette-dark .cc-cp-body-content-entry a{color:#fff;text-decoration:underline}.termsfeed-com---palette-dark .cc-cp-body-content-entry a:hover{text-decoration:none}.termsfeed-com---palette-dark .cc-cp-body-content-entry a:focus{box-shadow:0 0 0 2px #ff0}.termsfeed-com---palette-dark .cc-cp-foot{background:#212121;border-top-color:#111}.termsfeed-com---palette-dark .cc-cp-foot-byline{color:#fff}.termsfeed-com---palette-dark .cc-cp-foot-byline a:focus{box-shadow:0 0 0 2px #ff0}.termsfeed-com---palette-dark .cc-cp-foot-save{background:#ff0;color:#000}.termsfeed-com---palette-dark .cc-cp-foot-save:focus{box-shadow:0 0 0 2px #3dd000}",
            "",
        ]);
    },
    function (e, t, i) {
        var n = i(48);
        "string" == typeof n && (n = [[e.i, n, ""]]);
        var o = { hmr: !0, transform: void 0, insertInto: void 0 };
        i(1)(n, o);
        n.locals && (e.exports = n.locals);
    },
    function (e, t, i) {
        (e.exports = i(0)(!1)).push([
            e.i,
            ".termsfeed-com---palette-light.termsfeed-com---nb{background-color:#f2f2f2;color:#111}.termsfeed-com---palette-light .cc-nb-title{color:#111}.termsfeed-com---palette-light .cc-nb-text{color:#111}.termsfeed-com---palette-light .cc-nb-text a{color:#111;text-decoration:underline}.termsfeed-com---palette-light .cc-nb-text a:hover{text-decoration:none}.termsfeed-com---palette-light .cc-nb-text a:focus{box-shadow:0 0 0 2px #ff8d00}.termsfeed-com---palette-light .cc-nb-okagree{color:#fff;background-color:green}.termsfeed-com---palette-light .cc-nb-okagree:focus{box-shadow:0 0 0 2px #ff8d00}.termsfeed-com---palette-light .cc-nb-changep,.termsfeed-com---palette-light .cc-nb-reject{background-color:#eaeaea;color:#111}.termsfeed-com---palette-light .cc-nb-changep:focus, .termsfeed-com---palette-light .cc-nb-reject:focus{box-shadow:0 0 0 2px #ff8d00}.termsfeed-com---palette-light .cc-pc-container{background:#fff}.termsfeed-com---palette-light .cc-pc-head{background:#fff;color:#111;border-bottom:1px solid #ccc}.termsfeed-com---palette-light .cc-pc-head-title-headline{color:#111}.termsfeed-com---palette-light .cc-pc-head-title-text{color:#111}.termsfeed-com---palette-light .cc-pc-head-lang select{color:#111}.termsfeed-com---palette-light .cc-pc-head-lang select:focus{box-shadow:0 0 0 2px green}.termsfeed-com---palette-light .cc-pc-head-close{background:none;color:#666}.termsfeed-com---palette-light .cc-pc-head-close:active,.termsfeed-com---palette-light .cc-pc-head-close:focus{border:2px solid green}.termsfeed-com---palette-light .cc-cp-body{background:#fbfbfb !important;color:#111}.termsfeed-com---palette-light .cc-cp-body-tabs{color:#666;background:#e6e6e6}.termsfeed-com---palette-light .cc-cp-body-tabs-item{border-right-color:#ccc;border-bottom-color:#ccc}.termsfeed-com---palette-light .cc-cp-body-tabs-item-link{color:#666}.termsfeed-com---palette-light .cc-cp-body-tabs-item-link:hover{color:#666}.termsfeed-com---palette-light .cc-cp-body-tabs-item-link:focus{box-shadow:0 0 0 2px #fbfbfb}.termsfeed-com---palette-light .cc-cp-body-tabs-item[active=true]{background:#fbfbfb !important}.termsfeed-com---palette-light .cc-cp-body-tabs-item[active=true] button{color:#111}.termsfeed-com---palette-light .cc-cp-body-content{background:#fbfbfb !important;color:#111}.termsfeed-com---palette-light .cc-cp-body-content-entry-title{color:#111}.termsfeed-com---palette-light .cc-cp-body-content-entry-text{color:#111}.termsfeed-com---palette-light .cc-cp-body-content-entry a{color:#111;text-decoration:underline}.termsfeed-com---palette-light .cc-cp-body-content-entry a:hover{text-decoration:none}.termsfeed-com---palette-light .cc-cp-body-content-entry a:focus{box-shadow:0 0 0 2px green}.termsfeed-com---palette-light .cc-cp-foot{background:#f2f2f2;border-top-color:#ccc}.termsfeed-com---palette-light .cc-cp-foot-byline{color:#111}.termsfeed-com---palette-light .cc-cp-foot-byline a:focus{box-shadow:0 0 0 2px green}.termsfeed-com---palette-light .cc-cp-foot-save{background:green;color:#fff}.termsfeed-com---palette-light .cc-cp-foot-save:focus{box-shadow:0 0 0 2px #ff8d00}",
            "",
        ]);
    },
    function (e, t, i) {
        var n = i(50);
        "string" == typeof n && (n = [[e.i, n, ""]]);
        var o = { hmr: !0, transform: void 0, insertInto: void 0 };
        i(1)(n, o);
        n.locals && (e.exports = n.locals);
    },
    function (e, t, i) {
        (e.exports = i(0)(!1)).push([e.i, ".termsfeed-com---is-hidden{display:none}.termsfeed-com---is-visible{display:block}", ""]);
    },
    function (e, t, i) {
        var n = i(52);
        "string" == typeof n && (n = [[e.i, n, ""]]);
        var o = { hmr: !0, transform: void 0, insertInto: void 0 };
        i(1)(n, o);
        n.locals && (e.exports = n.locals);
    },
    function (e, t, i) {
        (e.exports = i(0)(!1)).push([e.i, ".termsfeed-com---nb.termsfeed-com---lang-ar,.termsfeed-com---pc-overlay.termsfeed-com---lang-ar{text-align:right}", ""]);
    },
    function (e, t, i) {
        "use strict";
        i.r(t),
            i.d(t, "run", function () {
                return _e;
            }),
            i.d(t, "cookieConsentObject", function () {
                return o;
            });
        i(38), i(41), i(43), i(45), i(47), i(49), i(51);
        var n,
            o,
            a = (function () {
                function e() {}
                return (
                    (e.appendChild = function (e, t, i) {
                        var n, o;
                        return (
                            void 0 === i && (i = null),
                            (n = "string" == typeof e ? document.querySelector(e) : e),
                            (o = "string" == typeof t ? document.querySelector(t) : t),
                            "afterbegin" === i ? n.insertAdjacentElement("afterbegin", o) : n.insertAdjacentElement("beforeend", o),
                            !0
                        );
                    }),
                    (e.setCookie = function (e, t, i, n, o) {
                        void 0 === o && (o = 62);
                        var a = new Date();
                        a.setTime(a.getTime() + 24 * o * 60 * 60 * 1e3);
                        var s = "; expires=" + a.toUTCString(),
                            r = "; domain=" + i,
                            c = "";
                        return n && (c = "; Secure"), (document.cookie = i ? e + "=" + (t || "") + r + s + ";path=/; samesite=strict" + c : e + "=" + (t || "") + s + ";path=/; samesite=strict" + c), !0;
                    }),
                    (e.getCookie = function (e) {
                        for (var t = e + "=", i = document.cookie.split(";"), n = 0; n < i.length; n++) {
                            for (var o = i[n]; " " === o.charAt(0); ) o = o.substring(1, o.length);
                            if (0 === o.indexOf(t)) return o.substring(t.length, o.length);
                        }
                        return null;
                    }),
                    (e.removeCookie = function (e) {
                        document.cookie = e + "=; Max-Age=-99999999;";
                    }),
                    (e.registerEvent = function (e) {
                        var t = document.createEvent("Event");
                        return t.initEvent(e, !0, !0), t;
                    }),
                    (e.searchObjectsArray = function (e, t, i) {
                        for (var n in e) {
                            if (e[n][t] === i) return !0;
                        }
                        return !1;
                    }),
                    (e.magicTransform = function (e) {
                        return decodeURIComponent(
                            atob(e)
                                .split("")
                                .map(function (e) {
                                    return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
                                })
                                .join("")
                        );
                    }),
                    (e.isValidUrl = function (e) {
                        return new RegExp("^(https?:\\/\\/)((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i").test(e);
                    }),
                    (e.isBoolean = function (e) {
                        return !1 === e || !0 === e;
                    }),
                    (e.getNonceFromScriptTag = function () {
                        try {
                            var e = document.querySelectorAll('script[type="text/javascript"]'),
                                t = /\/cookie-consent\.js$/,
                                i = null;
                            return (
                                e.forEach(function (e) {
                                    t.test(e.src) && (i = e.getAttribute("data-nonce"));
                                }),
                                i
                            );
                        } catch (e) {
                            return null;
                        }
                    }),
                    e
                );
            })(),
            s = i(2),
            r = i(3),
            c = i(4),
            l = i(5),
            p = i(6),
            d = i(7),
            u = i(8),
            _ = i(9),
            m = i(10),
            k = i(11),
            v = i(12),
            f = i(13),
            b = i(14),
            g = i(15),
            h = i(16),
            y = i(17),
            x = i(18),
            w = i(19),
            z = i(20),
            j = i(21),
            C = i(22),
            L = i(23),
            A = i(24),
            P = i(25),
            S = i(26),
            E = i(27),
            I = i(28),
            O = i(29),
            T = i(30),
            B = i(31),
            N = i(32),
            U = i(33),
            q = i(34),
            D = i(35),
            M = i(36),
            J = i(37),
            W = (function () {
                function e(e) {
                    (this.cookieConsent = e), (this.userLang = "en"), this.initAvailableLanguages(), this.initDefaultTranslations(), this.detectUserLanguage();
                }
                return (
                    (e.prototype.detectUserLanguage = function () {
                        var e = "en";
                        if (void 0 !== (e = void 0 !== navigator.languages ? navigator.languages[0] : navigator.language)) {
                            if (e.indexOf("-") > 0) {
                                var t = e.split("-");
                                e = t[0];
                            }
                            this.cookieConsent.log("[i18n] Detected owner website language set as: " + e, "info");
                        } else e = this.cookieConsent.ownerSiteLanguage;
                        var i = e.toLowerCase.toString();
                        this.availableTranslations[i] ? (this.userLang = i) : this.availableTranslations[this.cookieConsent.ownerSiteLanguage] ? (this.userLang = this.cookieConsent.ownerSiteLanguage) : (this.userLang = "en");
                    }),
                    (e.prototype.initDefaultTranslations = function () {
                        (this.availableTranslations = {
                            en: s,
                            en_gb: r,
                            de: c,
                            fr: l,
                            es: p,
                            ca_es: d,
                            it: u,
                            sv: _,
                            nl: m,
                            pt: k,
                            fi: v,
                            hu: f,
                            hr: b,
                            cs: g,
                            da: h,
                            ro: y,
                            sk: x,
                            sl: w,
                            pl: z,
                            sr: j,
                            et: C,
                            lt: L,
                            lv: A,
                            ru: P,
                            no: S,
                            bg: E,
                            el: I,
                            he: O,
                            uk: T,
                            mk: B,
                            cy: N,
                            ja: U,
                            ar: q,
                            tr: D,
                            zh_tw: M,
                            oc: J,
                        }),
                            this.cookieConsent.log("[i18n] Default translations initialized", "info");
                    }),
                    (e.prototype.initAvailableLanguages = function () {
                        (this.availableLanguages = [
                            { value: "en", title: "English" },
                            // { value: "en_gb", title: "English (UK)" },
                            // { value: "de", title: "German" },
                            // { value: "fr", title: "French" },
                            // { value: "es", title: "Spanish" },
                            // { value: "ca_es", title: "Catalan" },
                            // { value: "it", title: "Italian" },
                            // { value: "sv", title: "Swedish" },
                            // { value: "nl", title: "Dutch" },
                            // { value: "pt", title: "Portuguese" },
                            // { value: "fi", title: "Finnish" },
                            // { value: "hu", title: "Hungarian" },
                            // { value: "hr", title: "Croatian" },
                            // { value: "cs", title: "Czech" },
                            // { value: "da", title: "Danish" },
                            // { value: "ro", title: "Romanian" },
                            // { value: "sk", title: "Slovak" },
                            // { value: "sl", title: "Slovenian" },
                            { value: "pl", title: "Polski" },
                            // { value: "sr", title: "Serbian" },
                            // { value: "et", title: "Estonian" },
                            // { value: "lt", title: "Lithuanian" },
                            // { value: "lv", title: "Latvian" },
                            // { value: "ru", title: "Russian" },
                            // { value: "no", title: "Norwegian" },
                            // { value: "bg", title: "Bulgarian" },
                            // { value: "el", title: "Greek" },
                            // { value: "he", title: "Hebrew" },
                            { value: "uk", title: "Українська" },
                            // { value: "mk", title: "Macedonian" },
                            // { value: "cy", title: "Welsh" },
                            // { value: "ja", title: "Japanese" },
                            // { value: "ar", title: "Arabic" },
                            // { value: "tr", title: "Turkish" },
                            // { value: "zh_tw", title: "Traditional Chinese (zh-TW)" },
                            // { value: "oc", title: "Occitan" },
                        ]),
                            this.cookieConsent.log("[i18n] Default languages initialized", "info");
                    }),
                    (e.prototype.$t = function (e, t, i) {
                        void 0 === i && (i = null);
                        var n = this.availableTranslations[this.userLang][e][t];
                        return (
                            "string" == typeof i
                                ? (n = n.replace("%s", i))
                                : Array.isArray(i) &&
                                  i.map(function (e, t) {
                                      var o = i[t];
                                      n = n.replace("%s", o);
                                  }),
                            n || ""
                        );
                    }),
                    e
                );
            })(),
            F =
                ((n = function (e, t) {
                    return (n =
                        Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array &&
                            function (e, t) {
                                e.__proto__ = t;
                            }) ||
                        function (e, t) {
                            for (var i in t) t.hasOwnProperty(i) && (e[i] = t[i]);
                        })(e, t);
                }),
                function (e, t) {
                    function i() {
                        this.constructor = e;
                    }
                    n(e, t), (e.prototype = null === t ? Object.create(t) : ((i.prototype = t.prototype), new i()));
                }),
            R = function (e, t) {
                var i = "function" == typeof Symbol && e[Symbol.iterator];
                if (!i) return e;
                var n,
                    o,
                    a = i.call(e),
                    s = [];
                try {
                    for (; (void 0 === t || t-- > 0) && !(n = a.next()).done; ) s.push(n.value);
                } catch (e) {
                    o = { error: e };
                } finally {
                    try {
                        n && !n.done && (i = a.return) && i.call(a);
                    } finally {
                        if (o) throw o.error;
                    }
                }
                return s;
            },
            V = function () {
                for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(R(arguments[t]));
                return e;
            },
            K = function (e) {
                var t = "function" == typeof Symbol && Symbol.iterator,
                    i = t && e[t],
                    n = 0;
                if (i) return i.call(e);
                if (e && "number" == typeof e.length)
                    return {
                        next: function () {
                            return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
                        },
                    };
                throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
            },
            $ = (function () {
                function e(e) {
                    (this.acceptedLevels = {}),
                        (this.userAccepted = !1),
                        (this.consentLevelCookieName = "cookie_consent_level"),
                        (this.consentAcceptedCookieName = "cookie_consent_user_accepted"),
                        (this.cookieConsent = e),
                        this.cookieConsent.log("CookieConsent initialized", "info"),
                        this.checkIfUserAccepted(),
                        this.getUserLevels();
                }
                return (
                    (e.prototype.checkIfUserAccepted = function () {
                        "true" === a.getCookie(this.consentAcceptedCookieName) && (this.userAccepted = !0);
                    }),
                    (e.prototype.markUserAccepted = function () {
                        (this.userAccepted = !0), !1 === this.cookieConsent.isDemo && a.setCookie(this.consentAcceptedCookieName, "true", this.cookieConsent.ownerDomain, this.cookieConsent.cookieSecure, this.cookieConsent.cookieDuration);
                    }),
                    (e.prototype.getUserLevels = function () {
                        var e = a.getCookie(this.consentLevelCookieName),
                            t = {};
                        try {
                            t = JSON.parse(decodeURIComponent(e));
                        } catch (e) {
                            t = null;
                        }
                        if (null === t)
                            document.dispatchEvent(this.cookieConsent.events.cc_freshUser),
                                (this.acceptedLevels["strictly-necessary"] = !0),
                                "implied" === this.cookieConsent.ownerConsentType
                                    ? ((this.acceptedLevels.functionality = !0), (this.acceptedLevels.tracking = !0), (this.acceptedLevels.targeting = !0))
                                    : "express" === this.cookieConsent.ownerConsentType && ((this.acceptedLevels.functionality = !1), (this.acceptedLevels.tracking = !1), (this.acceptedLevels.targeting = !1));
                        else
                            for (var i in this.cookieConsent.cookieLevels.cookieLevels) {
                                var n = this.cookieConsent.cookieLevels.cookieLevels[i].id;
                                !0 === t[n] ? (this.acceptedLevels[n] = !0) : (this.acceptedLevels[n] = !1);
                            }
                        this.cookieConsent.log("Proposed accepted levels based on consent type are:", "info"), this.cookieConsent.log(this.acceptedLevels, "info", "table");
                    }),
                    (e.prototype.acceptAllCookieLevels = function () {
                        var e = this;
                        new Promise(function (t, i) {
                            for (var n in e.cookieConsent.cookieLevels.cookieLevels) {
                                var o = e.cookieConsent.cookieLevels.cookieLevels[n].id;
                                e.acceptLevel(o, !1);
                            }
                            t(!0);
                        }).then(function () {
                            document.dispatchEvent(e.cookieConsent.events.cc_scriptsAllLoaded), e.saveCookie();
                        });
                    }),
                    (e.prototype.rejectAllCookieLevels = function () {
                        var e = this;
                        new Promise(function (t, i) {
                            for (var n in e.cookieConsent.cookieLevels.cookieLevels) {
                                var o = e.cookieConsent.cookieLevels.cookieLevels[n].id;
                                "strictly-necessary" != o ? e.rejectLevel(o, !1) : "strictly-necessary" == o && e.acceptLevel(o, !1);
                            }
                            t(!0);
                        }).then(function () {
                            e.saveCookie();
                        });
                    }),
                    (e.prototype.loadAcceptedCookies = function () {
                        for (var e in this.cookieConsent.cookieLevels.cookieLevels) {
                            var t = this.cookieConsent.cookieLevels.cookieLevels[e].id;
                            !1 !== this.acceptedLevels[t] && this.cookieConsent.javascriptItems.enableScriptsByLevel(t);
                        }
                    }),
                    (e.prototype.acceptLevel = function (e, t) {
                        void 0 === t && (t = !0);
                        this.cookieConsent.log("Accepted cookie level: " + e, "info"), (this.acceptedLevels[e] = !0), t && this.saveCookie();
                    }),
                    (e.prototype.rejectLevel = function (e, t) {
                        void 0 === t && (t = !0);
                        this.cookieConsent.log("Rejected cookie level: " + e, "info"), (this.acceptedLevels[e] = !1), t && this.saveCookie();
                    }),
                    (e.prototype.saveCookie = function () {
                        var e = encodeURIComponent(JSON.stringify(this.acceptedLevels));
                        a.setCookie(this.consentLevelCookieName, e, this.cookieConsent.ownerDomain, this.cookieConsent.cookieSecure, this.cookieConsent.cookieDuration), this.cookieConsent.log("Saved cookie with user consent level", "info");
                        var t = this.cookieConsent.events.cc_userConsentSaved;
                        return (t.details = this.acceptedLevels), document.dispatchEvent(t), !0;
                    }),
                    e
                );
            })(),
            H = function () {
                (this.cc_noticeBannerShown = a.registerEvent("cc_noticeBannerShown")),
                    (this.cc_noticeBannerOkOrAgreePressed = a.registerEvent("cc_noticeBannerOkOrAgreePressed")),
                    (this.cc_noticeBannerRejectPressed = a.registerEvent("cc_noticeBannerRejectPressed")),
                    (this.cc_noticeBannerChangePreferencesPressed = a.registerEvent("cc_noticeBannerChangePreferencesPressed")),
                    (this.cc_preferencesCenterClosePressed = a.registerEvent("cc_preferencesCenterClosePressed")),
                    (this.cc_preferencesCenterSavePressed = a.registerEvent("cc_preferencesCenterSavePressed")),
                    (this.cc_userLanguageChanged = a.registerEvent("cc_userLanguageChanged")),
                    (this.cc_freshUser = a.registerEvent("cc_freshUser")),
                    (this.cc_userChangedConsent = a.registerEvent("cc_userChangedConsent")),
                    (this.cc_userConsentSaved = a.registerEvent("cc_userConsentSaved")),
                    (this.cc_scriptsAllLoaded = a.registerEvent("cc_scriptsAllLoaded")),
                    (this.cc_scriptsSpecificLoaded = a.registerEvent("cc_scriptsSpecificLoaded"));
            },
            G = (function () {
                function e(e) {
                    (this.scripts = {}), (this.cookieConsent = e), this.cookieConsent.log("Cookie Consent initialized", "info"), this.readScripts();
                }
                return (
                    (e.prototype.readScripts = function () {
                        var e = document.querySelectorAll('script[type="text/plain"]');
                        for (var t in e) {
                            var i = e[t];
                            "object" == typeof i && this._noticeScriptIfValid(i);
                        }
                    }),
                    (e.prototype._noticeScriptIfValid = function (e) {
                        var t = e.getAttribute("data-cookie-consent");
                        !0 === a.searchObjectsArray(this.cookieConsent.cookieLevels.cookieLevels, "id", t)
                            ? (this.cookieConsent.log("JavaScript script with valid data-cookie-consent tag found, but not loaded yet:", "info"),
                              this.cookieConsent.log(e, "info"),
                              void 0 === this.scripts[t] && (this.scripts[t] = []),
                              this.scripts[t].push(e))
                            : this.cookieConsent.log("Invalid cookie-consent tag level for JavaScript script: " + t, "warning");
                    }),
                    (e.prototype.enableScriptsByLevel = function (e) {
                        var t = this;
                        new Promise(function (i, n) {
                            var o = !1;
                            if (!t.scripts[e]) return i(o);
                            o = t.scripts[e].length > 0;
                            var s = function (i) {
                                try {
                                    var n = t.scripts[e][i],
                                        o = V(n.attributes),
                                        s = document.createElement("script");
                                    s.setAttribute("type", "text/javascript"),
                                        s.setAttribute("initial-data-cookie-consent", n.getAttribute("data-cookie-consent")),
                                        null !== n.getAttribute("src") && s.setAttribute("src", n.getAttribute("src")),
                                        o.reduce(function (e, t) {
                                            switch (t.name) {
                                                case "data-cookie-consent":
                                                case "type":
                                                    break;
                                                case "nonce":
                                                case "data-nonce":
                                                    s.setAttribute("nonce", t.value);
                                                    break;
                                                default:
                                                    s.setAttribute(t.name, t.value);
                                            }
                                        }, {}),
                                        (s.text = n.innerHTML),
                                        a.appendChild("head", s),
                                        n.parentNode.removeChild(n);
                                } catch (e) {
                                    t.cookieConsent.log("Error while trying to enable a JavaScript script: " + e.message.toString(), "log");
                                }
                                delete t.scripts[e][i];
                            };
                            for (var r in t.scripts[e]) s(r);
                            i(o);
                        }).then(function (i) {
                            if ((!0 === t.cookieConsent.forceCallbacksDispatching && t.cookieConsent.log("forceCallbacksDispatching is enabled", "log"), i || !0 === t.cookieConsent.forceCallbacksDispatching)) {
                                var n = t.cookieConsent.events.cc_scriptsSpecificLoaded;
                                (n.level = e), document.dispatchEvent(n);
                            }
                        });
                    }),
                    e
                );
            })(),
            Z = (function () {
                function e(e) {
                    (this.cookieConsent = e),
                        this.cc_noticeBannerShown(),
                        this.cc_noticeBannerOkOrAgreePressed(),
                        this.cc_preferencesCenterClosePressed(),
                        this.cc_noticeBannerRejectPressed(),
                        this.cc_noticeBannerChangePreferencesPressed(),
                        this.cc_userLanguageChanged(),
                        this.cc_preferencesCenterSavePressed(),
                        this.cc_freshUser(),
                        this.cc_userChangedConsent(),
                        this.cc_scriptsAllLoaded(),
                        this.cc_userConsentSaved(),
                        this.cc_scriptsSpecificLoaded();
                }
                return (
                    (e.prototype.cc_noticeBannerShown = function () {
                        var e = this;
                        window.addEventListener("cc_noticeBannerShown", function () {
                            e.cookieConsent.log("cc_noticeBannerShown triggered", "event"), e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_noticeBannerShown");
                        });
                    }),
                    (e.prototype.cc_noticeBannerOkOrAgreePressed = function () {
                        var e = this;
                        document.addEventListener("cc_noticeBannerOkOrAgreePressed", function () {
                            (this.userConsentTokenClass = new de(e.cookieConsent)),
                                e.cookieConsent.log("cc_noticeBannerOkOrAgreePressed triggered", "event"),
                                e.cookieConsent.userConsent.acceptAllCookieLevels(),
                                e.cookieConsent.userConsent.markUserAccepted(),
                                e.cookieConsent.pageRefreshConfirmationButtons ? window.location.reload() : e.cookieConsent.userConsent.loadAcceptedCookies(),
                                e.cookieConsent.noticeBannerContainer.hideNoticeBanner(),
                                e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_noticeBannerOkOrAgreePressed");
                        });
                    }),
                    (e.prototype.cc_noticeBannerRejectPressed = function () {
                        var e = this;
                        window.addEventListener("cc_noticeBannerRejectPressed", function () {
                            (this.userTokenClass = new de(e.cookieConsent)),
                                e.cookieConsent.log("cc_noticeBannerRejectPressed triggered", "event"),
                                e.cookieConsent.userConsent.rejectAllCookieLevels(),
                                e.cookieConsent.userConsent.markUserAccepted(),
                                e.cookieConsent.noticeBannerContainer.hideNoticeBanner(),
                                e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_noticeBannerRejectPressed"),
                                e.cookieConsent.preferencesCenterContainer.hidePreferencesCenter(),
                                e.cookieConsent.pageRefreshConfirmationButtons && window.location.reload();
                        });
                    }),
                    (e.prototype.cc_noticeBannerChangePreferencesPressed = function () {
                        var e = this;
                        window.addEventListener("cc_noticeBannerChangePreferencesPressed", function () {
                            e.cookieConsent.log("cc_noticeBannerChangePreferencesPressed triggered", "event"),
                                e.cookieConsent.preferencesCenterContainer.showPreferencesCenter(),
                                e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_noticeBannerChangePreferencesPressed");
                        });
                    }),
                    (e.prototype.cc_userLanguageChanged = function () {
                        var e = this;
                        window.addEventListener("cc_userLanguageChanged", function () {
                            e.cookieConsent.log("cc_userLanguageChanged triggered", "event"), e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_userLanguageChanged");
                        });
                    }),
                    (e.prototype.cc_preferencesCenterClosePressed = function () {
                        var e = this;
                        document.addEventListener("cc_preferencesCenterClosePressed", function () {
                            e.cookieConsent.log("cc_preferencesCenterClosePressed triggered", "event"),
                                e.cookieConsent.preferencesCenterContainer.hidePreferencesCenter(),
                                e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_preferencesCenterClosePressed");
                        });
                    }),
                    (e.prototype.cc_preferencesCenterSavePressed = function () {
                        var e = this;
                        window.addEventListener("cc_preferencesCenterSavePressed", function () {
                            (e.userConsentTokenClass = new de(e.cookieConsent)),
                                e.cookieConsent.log("cc_preferencesCenterSavePressed triggered", "event"),
                                e.cookieConsent.userConsent.markUserAccepted(),
                                e.cookieConsent.userConsent.saveCookie(),
                                e.cookieConsent.userConsent.loadAcceptedCookies(),
                                e.cookieConsent.preferencesCenterContainer.hidePreferencesCenter(),
                                e.cookieConsent.noticeBannerContainer.hideNoticeBanner(),
                                e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_preferencesCenterSavePressed"),
                                e.cookieConsent.pageRefreshConfirmationButtons && window.location.reload();
                        });
                    }),
                    (e.prototype.cc_freshUser = function () {
                        var e = this;
                        window.addEventListener("cc_freshUser", function () {
                            e.cookieConsent.log("cc_freshUser triggered", "event"), e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_freshUser");
                        });
                    }),
                    (e.prototype.cc_userChangedConsent = function () {
                        var e = this;
                        window.addEventListener("cc_userChangedConsent", function () {
                            e.cookieConsent.log("cc_userChangedConsent triggered", "event"), e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_userChangedConsent");
                        });
                    }),
                    (e.prototype.cc_userConsentSaved = function () {
                        var e = this;
                        window.addEventListener("cc_userConsentSaved", function (t) {
                            e.cookieConsent.log("cc_userConsentSaved triggered", "event"), e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_userConsentSaved", t.details);
                        });
                    }),
                    (e.prototype.cc_scriptsAllLoaded = function () {
                        var e = this;
                        window.addEventListener("cc_scriptsAllLoaded", function () {
                            e.cookieConsent.log("cc_scriptsAllLoaded triggered", "event"), e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_scriptsAllLoaded");
                        });
                    }),
                    (e.prototype.cc_scriptsSpecificLoaded = function () {
                        var e = this;
                        window.addEventListener("cc_scriptsSpecificLoaded", function (t) {
                            e.cookieConsent.log("cc_scriptsSpecificLoaded triggered", "event"), e.cookieConsent.customerCallbacks.callCustomerCallbackByEvent("cc_scriptsSpecificLoaded", t.level);
                        });
                    }),
                    e
                );
            })(),
            Y = (function () {
                function e(e, t) {
                    (this.cookieConsent = e), this.cookieConsent.log("CustomerCallbacks initialized", "info"), this.cookieConsent.log(t, "info"), (this.customerCallbacksObject = t);
                }
                return (
                    (e.prototype.callCustomerCallbackByEvent = function (e, t) {
                        void 0 === t && (t = null);
                        try {
                            var i = {
                                cc_noticeBannerShown: "notice_banner_loaded",
                                cc_noticeBannerOkOrAgreePressed: "i_agree_button_clicked",
                                cc_noticeBannerRejectPressed: "i_decline_button_clicked",
                                cc_noticeBannerChangePreferencesPressed: "change_my_preferences_button_clicked",
                                cc_scriptsAllLoaded: "scripts_all_loaded",
                                cc_scriptsSpecificLoaded: "scripts_specific_loaded",
                                cc_userConsentSaved: "user_consent_saved",
                            }[e];
                            if ((this.cookieConsent.log("Calling Customer Callback: " + i, "info"), "function" == typeof this.customerCallbacksObject[i])) this.customerCallbacksObject[i](t);
                            else {
                                var n = window[this.customerCallbacksObject[i]];
                                "function" == typeof n && n(t);
                            }
                        } catch (e) {}
                    }),
                    e
                );
            })(),
            Q = (function () {
                function e(e) {
                    (this.cookieConsent = e), this.initPreferenceItems();
                }
                return (
                    (e.prototype.languageChanged = function () {
                        this.initPreferenceItems();
                    }),
                    (e.prototype.initPreferenceItems = function () {
                        var e, t;
                        (this.preferenceItems = [
                            {
                                title: this.cookieConsent.i18n.$t("i18n", "pc_yprivacy_title"),
                                title_container: "title_your_privacy",
                                content_container: "content_your_privacy",
                                content:
                                    "<p class='cc-cp-body-content-entry-title'>" +
                                    this.cookieConsent.i18n.$t("i18n", "pc_yprivacy_text_1") +
                                    "</p><p class='cc-cp-body-content-entry-text'>" +
                                    this.cookieConsent.i18n.$t("i18n", "pc_yprivacy_text_2") +
                                    "</p><p class='cc-cp-body-content-entry-text'>" +
                                    this.cookieConsent.i18n.$t("i18n", "pc_yprivacy_text_3") +
                                    "</p>",
                            },
                        ]),
                            (this.cookieLevels = [
                                {
                                    id: "strictly-necessary",
                                    title: this.cookieConsent.i18n.$t("i18n", "pc_sncssr_text_1"),
                                    content:
                                        "<p class='cc-cp-body-content-entry-title'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_sncssr_text_1") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_sncssr_text_2") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_sncssr_text_3") +
                                        "</p>",
                                },
                                {
                                    id: "functionality",
                                    title: this.cookieConsent.i18n.$t("i18n", "pc_fnct_text_1"),
                                    content:
                                        "<p class='cc-cp-body-content-entry-title'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_fnct_text_1") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_fnct_text_2") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_fnct_text_3") +
                                        "</p>",
                                },
                                {
                                    id: "tracking",
                                    title: this.cookieConsent.i18n.$t("i18n", "pc_trck_text_1"),
                                    content:
                                        "<p class='cc-cp-body-content-entry-title'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_trck_text_1") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_trck_text_2") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_trck_text_3") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_trck_text_4") +
                                        "</p>",
                                },
                                {
                                    id: "targeting",
                                    title: this.cookieConsent.i18n.$t("i18n", "pc_trgt_text_1"),
                                    content:
                                        "<p class='cc-cp-body-content-entry-title'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_trgt_text_1") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_trgt_text_2") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_trgt_text_3") +
                                        "</p><p class='cc-cp-body-content-entry-text'>" +
                                        this.cookieConsent.i18n.$t("i18n", "pc_trgt_text_4") +
                                        "</p>",
                                },
                            ]);
                        try {
                            for (var i = K(this.cookieLevels), n = i.next(); !n.done; n = i.next()) {
                                var o = n.value;
                                this.preferenceItems.push({ id: o.id, title: o.title, title_container: "title_" + o.id, content_container: "content_" + o.id, content: o.content });
                            }
                        } catch (t) {
                            e = { error: t };
                        } finally {
                            try {
                                n && !n.done && (t = i.return) && t.call(i);
                            } finally {
                                if (e) throw e.error;
                            }
                        }
                        this.preferenceItems.push({
                            title: this.cookieConsent.i18n.$t("i18n", "pc_minfo_text_1"),
                            title_container: "title_more_information",
                            content_container: "content_more_information",
                            content:
                                "<p class='cc-cp-body-content-entry-title'>" +
                                this.cookieConsent.i18n.$t("i18n", "pc_minfo_text_1") +
                                "</p><p class='cc-cp-body-content-entry-text'>" +
                                this.cookieConsent.i18n.$t("i18n", "pc_minfo_text_2") +
                                "</p>",
                        }),
                            null !== this.cookieConsent.ownerWebsitePrivacyPolicyUrl &&
                                a.isValidUrl(this.cookieConsent.ownerWebsitePrivacyPolicyUrl) &&
                                (this.preferenceItems[this.preferenceItems.length - 1].content =
                                    this.preferenceItems[this.preferenceItems.length - 1].content +
                                    "<p class='cc-cp-body-content-entry-text'>" +
                                    this.cookieConsent.i18n.$t("i18n", "pc_minfo_text_3", this.cookieConsent.ownerWebsitePrivacyPolicyUrl) +
                                    "</p>");
                    }),
                    e
                );
            })(),
            X = (function () {
                function e(e) {
                    (this.preferencesCenterOverlay = null), (this.cookieConsent = e);
                }
                return (
                    (e.prototype.listenToUserButtonToOpenPreferences = function (e) {
                        var t = this,
                            i = document.querySelectorAll(e);
                        t.cookieConsent.log("userButton detected:", "info"),
                            t.cookieConsent.log(i, "info", "table"),
                            i &&
                                i.forEach(function (e) {
                                    e.addEventListener("click", function () {
                                        document.dispatchEvent(t.cookieConsent.events.cc_noticeBannerChangePreferencesPressed), t.showPreferencesCenter();
                                    });
                                });
                    }),
                    (e.prototype.showPreferencesCenter = function () {
                        var e,
                            t = this;
                        null === this.preferencesCenterOverlay && ((this.preferencesCenterOverlay = this.createPreferencesCenterOverlayAndDialog()), a.appendChild("body", this.preferencesCenterOverlay)),
                            this.preferencesCenterOverlay.classList.add("termsfeed-com---is-visible"),
                            t.cookieConsent.log("Preferences Center shown", "info"),
                            this.preferencesCenterOverlay.setAttribute("role", "dialog"),
                            this.preferencesCenterOverlay.setAttribute("aria-labelledby", "cc-pc-head-title-headline"),
                            this.preferencesCenterOverlay.setAttribute("tabindex", "-1"),
                            this.preferencesCenterOverlay.focus();
                        var i = document.querySelector("#termsfeed-com---preferences-center"),
                            n = i.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0],
                            o = i.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
                            s = o[o.length - 1];
                        t.cookieConsent.log("preferencesCenterOverlayModal_firstFocusableElement: " + n, "info"),
                            t.cookieConsent.log("preferencesCenterOverlayModal_focusableContent: " + o, "info"),
                            t.cookieConsent.log("preferencesCenterOverlayModal_lastFocusableElement: " + s, "info"),
                            document.addEventListener("keydown", function (e) {
                                var i, o;
                                ("Tab" === e.key || 9 === e.keyCode) &&
                                    (e.shiftKey
                                        ? document.activeElement === n &&
                                          (t.cookieConsent.log("preferencesCenterOverlayModal_lastFocusableElement before focus: " + s, "info"), null === (i = s) || void 0 === i || i.focus(), e.preventDefault())
                                        : document.activeElement === s &&
                                          (t.cookieConsent.log("preferencesCenterOverlayModal_firstFocusableElement before focus: " + n, "info"), null === (o = n) || void 0 === o || o.focus(), e.preventDefault()));
                            }),
                            t.cookieConsent.log("preferencesCenterOverlayModal_firstFocusableElement before focus: " + n, "info"),
                            null === (e = n) || void 0 === e || e.focus(),
                            this.preferencesCenterOverlay.classList.add("termsfeed-com---lang-" + t.cookieConsent.i18n.userLang);
                    }),
                    (e.prototype.hidePreferencesCenter = function () {
                        this.preferencesCenterOverlay.classList.remove("termsfeed-com---is-visible"), this.cookieConsent.log("Preferences Center hidden", "info");
                    }),
                    (e.prototype.refreshPreferencesCenter = function () {
                        if (null !== this.preferencesCenterOverlay) return this.preferencesCenterOverlay.parentNode.removeChild(this.preferencesCenterOverlay), (this.preferencesCenterOverlay = null), this.showPreferencesCenter();
                    }),
                    (e.prototype.createPreferencesCenterOverlayAndDialog = function () {
                        var e = this,
                            t = document.createElement("div");
                        t.classList.add("termsfeed-com---pc-overlay"),
                            t.classList.add(e.cookieConsent.colorPalette.getClass()),
                            t.classList.add("termsfeed-com---reset"),
                            (t.id = "termsfeed-com---preferences-center"),
                            t.setAttribute("id", "termsfeed-com---preferences-center");
                        var i = document.createElement("div");
                        i.classList.add("termsfeed-com---pc-dialog");
                        var n = document.createElement("div");
                        n.classList.add("cc-pc-container");
                        var o = document.createElement("div");
                        o.classList.add("cc-pc-head");
                        var s = document.createElement("div");
                        if ((s.classList.add("cc-pc-head-title"), e.cookieConsent.ownerWebsiteName.length > 2)) {
                            var r = document.createElement("p");
                            r.classList.add("cc-pc-head-title-text"), (r.innerText = e.cookieConsent.ownerWebsiteName), a.appendChild(s, r);
                        }
                        var c = document.createElement("p");
                        c.classList.add("cc-pc-head-title-headline"), c.setAttribute("id", "cc-pc-head-title-headline"), (c.innerHTML = e.cookieConsent.i18n.$t("i18n", "pc_title")), a.appendChild(s, c);
                        var l = document.createElement("div");
                        l.classList.add("cc-pc-head-lang");
                        var p = this.obtainLanguageSelector();
                        a.appendChild(l, p);
                        var d = document.createElement("button");
                        d.classList.add("cc-pc-head-close"),
                            (d.innerHTML = "&#x2715;"),
                            d.addEventListener("click", function () {
                                document.dispatchEvent(e.cookieConsent.events.cc_preferencesCenterClosePressed);
                            }),
                            a.appendChild(o, s),
                            a.appendChild(o, l),
                            !1 === e.cookieConsent.ownerPreferencesCenterCloseButtonHide && a.appendChild(l, d, "afterbegin");
                        var u = document.createElement("div");
                        u.classList.add("cc-cp-body");
                        var _ = this.getMenuContainer(),
                            m = this.getContentContainer();
                        a.appendChild(u, _), a.appendChild(u, m);
                        var k = this.getFooterContainer();
                        return a.appendChild(n, o), a.appendChild(n, u), a.appendChild(n, k), a.appendChild(i, n), a.appendChild(t, i), t;
                    }),
                    (e.prototype.obtainLanguageSelector = function () {
                        var e = this,
                            t = document.createElement("select");
                        return (
                            t.classList.add("cc-pc-head-lang-select"),
                            [].forEach.call(e.cookieConsent.i18n.availableLanguages, function (i) {
                                var n = document.createElement("option");
                                (n.text = i.title), (n.value = i.value), e.cookieConsent.i18n.userLang === n.value && n.setAttribute("selected", "selected"), t.add(n);
                            }),
                            t.addEventListener("change", function () {
                                (e.cookieConsent.i18n.userLang = t.value), e.cookieConsent.cookieLevels.languageChanged(), e.refreshPreferencesCenter(), document.dispatchEvent(e.cookieConsent.events.cc_userLanguageChanged);
                            }),
                            t
                        );
                    }),
                    (e.prototype.getContentContainer = function () {
                        var e = this,
                            t = document.createElement("div");
                        t.classList.add("cc-cp-body-content");
                        var i = 0;
                        return (
                            e.cookieConsent.cookieLevels.preferenceItems.forEach(function (n) {
                                var o = document.createElement("div");
                                if (
                                    (o.classList.add("cc-cp-body-content-entry"),
                                    o.setAttribute("id", n.content_container),
                                    o.setAttribute("role", "tabpanel"),
                                    o.setAttribute("aria-labelledby", n.title_container),
                                    o.setAttribute("hidden", ""),
                                    o.setAttribute("tabindex", "0"),
                                    o.setAttribute("content_layout", n.content_container),
                                    o.setAttribute("active", "false"),
                                    (o.innerHTML = n.content),
                                    0 === i && (o.setAttribute("active", "true"), o.removeAttribute("hidden")),
                                    i++,
                                    n.id)
                                ) {
                                    var s = e._getLevelCheckbox(n);
                                    a.appendChild(o, s);
                                }
                                a.appendChild(t, o);
                            }),
                            t
                        );
                    }),
                    (e.prototype.getMenuContainer = function () {
                        var e = this,
                            t = document.createElement("ul");
                        t.classList.add("cc-cp-body-tabs"), t.setAttribute("role", "tablist"), t.setAttribute("aria-label", "Menu");
                        var i = 0;
                        return (
                            e.cookieConsent.cookieLevels.preferenceItems.forEach(function (n) {
                                var o = document.createElement("li");
                                o.classList.add("cc-cp-body-tabs-item");
                                var s = document.createElement("button");
                                s.classList.add("cc-cp-body-tabs-item-link"),
                                    s.setAttribute("id", n.title_container),
                                    s.setAttribute("role", "tab"),
                                    s.setAttribute("aria-selected", "false"),
                                    s.setAttribute("aria-controls", n.content_container),
                                    s.setAttribute("tabindex", "-1"),
                                    s.setAttribute("t", n.content_container),
                                    (s.innerHTML = n.title),
                                    0 === i && (o.setAttribute("active", "true"), s.setAttribute("aria-selected", "true"), s.setAttribute("tabindex", "0")),
                                    i++,
                                    s.addEventListener("click", function (t) {
                                        t.preventDefault(), e.cookieConsent.log("Preferences Center tab item clicked: " + n.title, "info");
                                        var i = document.querySelectorAll('li[active="true"]');
                                        [].forEach.call(i, function (e) {
                                            e.setAttribute("active", "false"), e.firstElementChild.setAttribute("aria-selected", "false"), e.firstElementChild.setAttribute("tabindex", "-1");
                                        }),
                                            o.setAttribute("active", "true"),
                                            o.firstElementChild.setAttribute("aria-selected", "true"),
                                            o.firstElementChild.setAttribute("tabindex", "0");
                                        try {
                                            var a = document.querySelectorAll("div[content_layout]");
                                            [].forEach.call(a, function (e) {
                                                e.setAttribute("active", "false"), e.setAttribute("hidden", "");
                                            });
                                            var s = document.querySelector('div[content_layout="' + n.content_container + '"]');
                                            s.setAttribute("active", "true"), s.removeAttribute("hidden");
                                        } catch (t) {}
                                    });
                                var r = 0,
                                    c = document.getElementsByClassName("cc-cp-body-tabs-item-link");
                                t.addEventListener("keydown", function (e) {
                                    ("ArrowDown" !== e.key && "ArrowUp" !== e.key && "ArrowLeft" !== e.key && "ArrowRight" !== e.key) ||
                                        (c[r].setAttribute("tabindex", "-1"),
                                        "ArrowDown" === e.key || "ArrowRight" === e.key ? ++r >= c.length && (r = 0) : ("ArrowUp" !== e.key && "ArrowLeft" !== e.key) || (--r < 0 && (r = c.length - 1)),
                                        c[r].setAttribute("tabindex", "0"),
                                        c[r].focus());
                                }),
                                    a.appendChild(o, s),
                                    a.appendChild(t, o);
                            }),
                            t
                        );
                    }),
                    (e.prototype.getFooterContainer = function () {
                        var e = this,
                            t = document.createElement("div");
                        t.classList.add("cc-cp-foot");
                        var i = document.createElement("div");
                        i.classList.add("cc-cp-foot-byline"), (i.innerHTML = a.magicTransform("Q29va2llIENvbnNlbnQgYnkgPGEgaHJlZj0iaHR0cHM6Ly93d3cudGVybXNmZWVkLmNvbS9jb29raWUtY29uc2VudC8iIHRhcmdldD0iX2JsYW5rIj5UZXJtc0ZlZWQ8L2E+"));
                        var n = document.createElement("div");
                        n.classList.add("cc-cp-foot-button");
                        var y = document.createElement("div");
                        y.classList.add("cc-cp-foot-button");
                        var o = document.createElement("button");
                        var z = document.createElement("button");
                        return (
                            o.classList.add("cc-cp-foot-save"),
                            (o.innerHTML = e.cookieConsent.i18n.$t("i18n", "pc_save")),
                            o.addEventListener("click", function () {
                                document.dispatchEvent(e.cookieConsent.events.cc_preferencesCenterSavePressed);
                            }),
                           
                            z.classList.add("cc-nb-reject"),
                            z.setAttribute("role", "button"),
                            (z.innerHTML = e.cookieConsent.i18n.$t("i18n", "nb_reject")),
                            z.addEventListener("click", function () {
                                document.dispatchEvent(e.cookieConsent.events.cc_noticeBannerRejectPressed);
                            }),
                            a.appendChild(n, z),
                            a.appendChild(n, o),
                            a.appendChild(t, i),
                            a.appendChild(t, y),
                            a.appendChild(t, n),
                            t
                        );
                        
                    }),
                    (e.prototype._getLevelCheckbox = function (e) {
                        var t = this,
                            i = document.createElement("div");
                        if ((i.classList.add("cc-custom-checkbox"), "strictly-necessary" !== e.id)) {
                            var n = t.cookieConsent.userConsent.acceptedLevels,
                                o = document.createElement("input");
                            o.setAttribute("cookie_consent_toggler", "true"),
                                o.setAttribute("type", "checkbox"),
                                o.setAttribute("class", "cc-custom-checkbox"),
                                o.setAttribute("id", e.id),
                                o.setAttribute("name", e.id),
                                o.setAttribute("aria-labelledby", e.id + "_label"),
                                (s = document.createElement("label")).setAttribute("for", e.id),
                                s.setAttribute("id", e.id + "_label"),
                                n[e.id]
                                    ? (o.setAttribute("checked", "checked"), o.setAttribute("aria-checked", "true"), s.setAttribute("class", "is-active"), (s.innerHTML = t.cookieConsent.i18n.$t("i18n", "active")))
                                    : (o.setAttribute("aria-checked", "false"), s.setAttribute("class", "is-inactive"), (s.innerHTML = t.cookieConsent.i18n.$t("i18n", "inactive"))),
                                o.addEventListener("change", function () {
                                    var i = o.checked,
                                        n = e.id,
                                        a = document.querySelector('label[for="' + n + '"]');
                                    t.cookieConsent.log("User changed cookie level [" + n + "], new status: " + i, "info"),
                                        document.dispatchEvent(t.cookieConsent.events.cc_userChangedConsent),
                                        !0 === i
                                            ? (t.cookieConsent.userConsent.acceptLevel(n, !1), (a.innerHTML = t.cookieConsent.i18n.$t("i18n", "active")))
                                            : (t.cookieConsent.userConsent.rejectLevel(n, !1), (a.innerHTML = t.cookieConsent.i18n.$t("i18n", "inactive")));
                                }),
                                o.addEventListener("keypress", function (e) {
                                    if (" " === e.key || "Spacebar" === e.key)
                                        switch (o.getAttribute("aria-checked")) {
                                            case "true":
                                                o.setAttribute("aria-checked", "false");
                                                break;
                                            case "false":
                                                o.setAttribute("aria-checked", "true");
                                        }
                                }),
                                a.appendChild(i, o),
                                a.appendChild(i, s);
                        } else {
                            var s,
                                r = document.createElement("input");
                            r.setAttribute("cookie_consent_toggler", "true"),
                                r.setAttribute("type", "checkbox"),
                                r.setAttribute("checked", "checked"),
                                r.setAttribute("aria-checked", "true"),
                                r.setAttribute("disabled", "disabled"),
                                r.setAttribute("class", "cc-custom-checkbox"),
                                r.setAttribute("id", e.id),
                                r.setAttribute("name", e.id),
                                r.setAttribute("aria-labelledby", e.id + "_label"),
                                r.setAttribute("tabindex", "0"),
                                (s = document.createElement("label")).setAttribute("for", e.id),
                                s.setAttribute("id", e.id + "_label"),
                                (s.innerHTML = t.cookieConsent.i18n.$t("i18n", "always_active")),
                                a.appendChild(i, r),
                                a.appendChild(i, s);
                        }
                        return i;
                    }),
                    e
                );
            })(),
            ee = (function () {
                function e(e) {
                    (this.noticeBanner = null), (this.noticeBannerOverlay = null), (this.noticeBannerExtraCss = []), (this.cookieConsent = e), this.noticeBannerExtraCss.push(e.colorPalette.getClass());
                }
                return (
                    (e.prototype.initNoticeBanner = function () {
                        var e, t;
                        if (
                            (null === this.noticeBanner && (this.noticeBanner = this.createNoticeBanner()),
                            (t =
                                "afterbegin" === this.cookieConsent.ownerNoticeBannerAppendContentPosition || "beforeend" === this.cookieConsent.ownerNoticeBannerAppendContentPosition
                                    ? this.cookieConsent.ownerNoticeBannerAppendContentPosition
                                    : "afterbegin"),
                            a.appendChild("body", this.noticeBanner, t),
                            this.cookieConsent.log("Notice Banner shown " + t, "info"),
                            document.dispatchEvent(this.cookieConsent.events.cc_noticeBannerShown),
                            "interstitial" === this.cookieConsent.ownerNoticeBannerType || "standalone" === this.cookieConsent.ownerNoticeBannerType)
                        ) {
                            var i = document.querySelector("#termsfeed-com---nb"),
                                n = i.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0],
                                o = i.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
                                s = o[o.length - 1];
                            document.addEventListener("keydown", function (e) {
                                var t, i;
                                ("Tab" === e.key || 9 === e.keyCode) &&
                                    (e.shiftKey
                                        ? document.activeElement === n && (null === (t = s) || void 0 === t || t.focus(), e.preventDefault())
                                        : document.activeElement === s && (null === (i = n) || void 0 === i || i.focus(), e.preventDefault()));
                            }),
                                null === (e = n) || void 0 === e || e.focus();
                        }
                        return !0;
                    }),
                    (e.prototype.hideNoticeBanner = function () {
                        try {
                            this.noticeBanner.classList.add("termsfeed-com---is-hidden"), this.cookieConsent.log("Notice Banner hidden", "info");
                        } catch (e) {}
                    }),
                    (e.prototype.createNoticeBanner = function () {
                        var e,
                            t,
                            i = document.createElement("div");
                        if (
                            (i.classList.add("termsfeed-com---reset"),
                            i.classList.add("termsfeed-com---nb"),
                            i.setAttribute("id", "termsfeed-com---nb"),
                            i.setAttribute("role", "dialog"),
                            i.setAttribute("aria-modal", "true"),
                            i.setAttribute("aria-labelledby", "cc-nb-title"),
                            i.setAttribute("aria-describedby", "cc-nb-text"),
                            this.noticeBannerExtraCss.length)
                        )
                            try {
                                for (var n = K(this.noticeBannerExtraCss), o = n.next(); !o.done; o = n.next()) {
                                    var s = o.value;
                                    i.classList.add(s);
                                }
                            } catch (t) {
                                e = { error: t };
                            } finally {
                                try {
                                    o && !o.done && (t = n.return) && t.call(n);
                                } finally {
                                    if (e) throw e.error;
                                }
                            }
                        if ((i.classList.add("termsfeed-com---lang-" + this.cookieConsent.i18n.userLang), a.appendChild(i, this.createNoticeBannerContent()), "interstitial" === this.cookieConsent.ownerNoticeBannerType)) {
                            var r = document.createElement("div");
                            return r.classList.add("termsfeed-com---nb-interstitial-overlay"), a.appendChild(r, i), r;
                        }
                        return i;
                    }),
                    (e.prototype.createNoticeBannerContent = function () {
                        var e = this,
                            t = document.createElement("div");
                        t.classList.add("cc-nb-main-container");
                        var i = document.createElement("div");
                        i.classList.add("cc-nb-title-container");
                        var n = document.createElement("p");
                        n.classList.add("cc-nb-title"), n.setAttribute("id", "cc-nb-title"), (n.innerText = e.cookieConsent.i18n.$t("i18n", "nb_title")), a.appendChild(i, n);
                        var o = document.createElement("div");
                        o.classList.add("cc-nb-text-container");
                        var s = document.createElement("p");
                        s.classList.add("cc-nb-text"), s.setAttribute("id", "cc-nb-text"), (s.innerHTML = e.cookieConsent.i18n.$t("i18n", "nb_text"));
                        var r = document.createElement("span");
                        r.classList.add("cc-nb-text-urls"), (r.innerHTML = " ");
                        var c = document.createElement("span");
                        c.classList.add("cc-nb-text-urls-privacy"), c.setAttribute("role", "link");
                        var l = document.createElement("span");
                        l.classList.add("cc-nb-text-urls-impressum"), l.setAttribute("role", "link");
                        var p = document.createElement("span");
                        p.classList.add("cc-nb-text-urls-separator"),
                            (p.innerHTML = " | "),
                            e.cookieConsent.noticeBannerInsertLegalUrls &&
                                (e.cookieConsent.ownerWebsitePrivacyPolicyUrl && e.cookieConsent.ownerWebsiteImpressumUrl
                                    ? a.isValidUrl(e.cookieConsent.ownerWebsitePrivacyPolicyUrl) &&
                                      a.isValidUrl(e.cookieConsent.ownerWebsiteImpressumUrl) &&
                                      ((c.innerHTML = e.cookieConsent.i18n.$t("i18n", "privacy_policy", e.cookieConsent.ownerWebsitePrivacyPolicyUrl)),
                                      (l.innerHTML = e.cookieConsent.i18n.$t("i18n", "impressum", e.cookieConsent.ownerWebsiteImpressumUrl)),
                                      a.appendChild(r, c),
                                      a.appendChild(c, p),
                                      a.appendChild(r, l))
                                    : e.cookieConsent.ownerWebsitePrivacyPolicyUrl && a.isValidUrl(e.cookieConsent.ownerWebsitePrivacyPolicyUrl)
                                    ? ((c.innerHTML = e.cookieConsent.i18n.$t("i18n", "privacy_policy", e.cookieConsent.ownerWebsitePrivacyPolicyUrl)), a.appendChild(r, c))
                                    : e.cookieConsent.ownerWebsiteImpressumUrl &&
                                      a.isValidUrl(e.cookieConsent.ownerWebsiteImpressumUrl) &&
                                      ((l.innerHTML = e.cookieConsent.i18n.$t("i18n", "impressum", e.cookieConsent.ownerWebsiteImpressumUrl)), a.appendChild(r, l)),
                                a.appendChild(s, r)),
                            a.appendChild(o, s);
                        var d = document.createElement("div");
                        d.classList.add("cc-nb-buttons-container");
                        var u = document.createElement("button");
                        u.classList.add("cc-nb-okagree"),
                            u.setAttribute("role", "button"),
                            "express" == e.cookieConsent.ownerConsentType ? (u.innerHTML = e.cookieConsent.i18n.$t("i18n", "nb_agree")) : (u.innerHTML = e.cookieConsent.i18n.$t("i18n", "nb_ok")),
                            u.addEventListener("click", function () {
                                document.dispatchEvent(e.cookieConsent.events.cc_noticeBannerOkOrAgreePressed);
                            }),
                            a.appendChild(d, u);
                        //
                        var m = document.createElement("button");
                        return (
                            m.classList.add("cc-nb-changep"),
                            m.setAttribute("role", "button"),
                            (m.innerHTML = e.cookieConsent.i18n.$t("i18n", "nb_changep")),
                            m.addEventListener("click", function () {
                                document.dispatchEvent(e.cookieConsent.events.cc_noticeBannerChangePreferencesPressed);
                            }),
                            a.appendChild(d, m),
                            a.appendChild(t, i),
                            a.appendChild(t, o),
                            a.appendChild(t, d),
                            t
                        );
                    }),
                    e
                );
            })(),
            te = (function (e) {
                function t(t) {
                    var i = e.call(this, t) || this;
                    return i.noticeBannerExtraCss.push("termsfeed-com---nb-simple"), i;
                }
                return F(t, e), t;
            })(ee),
            ie = (function (e) {
                function t(t) {
                    var i = e.call(this, t) || this;
                    return i.noticeBannerExtraCss.push("termsfeed-com---nb-headline"), i;
                }
                return F(t, e), t;
            })(ee),
            ne = (function (e) {
                function t(t) {
                    var i = e.call(this, t) || this;
                    return i.noticeBannerExtraCss.push("termsfeed-com---nb-interstitial"), i;
                }
                return F(t, e), t;
            })(ee),
            oe = (function (e) {
                function t(t) {
                    var i = e.call(this, t) || this;
                    return i.noticeBannerExtraCss.push("termsfeed-com---nb-standalone"), i;
                }
                return F(t, e), t;
            })(ee),
            ae = (function () {
                function e(e) {
                    e.log("ConsentType main class initialized", "info");
                }
                return (e.prototype.loadInitialCookiesForNewUser = function () {}), e;
            })(),
            se = (function (e) {
                function t(t) {
                    var i = e.call(this, t) || this;
                    return (i.cookieConsent = t), i;
                }
                return (
                    F(t, e),
                    (t.prototype.loadInitialCookiesForNewUser = function () {
                        var e = this;
                        e.cookieConsent.log("consentImplied loadInitialCookiesForNewUser triggered", "info");
                        var t = !1,
                            i = !1,
                            n = !1;
                        if (null !== e.cookieConsent.ownerPageLoadConsentLevels)
                            for (var o in e.cookieConsent.ownerPageLoadConsentLevels) {
                                var a = e.cookieConsent.ownerPageLoadConsentLevels[o];
                                "functionality" == a && (t = !0), "tracking" == a && (i = !0), "targeting" == a && (n = !0);
                            }
                        else (t = !0), (i = !0), (n = !0);
                        new Promise(function (o, a) {
                            e.cookieConsent.javascriptItems.enableScriptsByLevel("strictly-necessary"),
                                t ? (e.cookieConsent.userConsent.acceptLevel("functionality", !1), e.cookieConsent.javascriptItems.enableScriptsByLevel("functionality")) : e.cookieConsent.userConsent.rejectLevel("functionality", !1),
                                i ? (e.cookieConsent.userConsent.acceptLevel("tracking", !1), e.cookieConsent.javascriptItems.enableScriptsByLevel("tracking")) : e.cookieConsent.userConsent.rejectLevel("tracking", !1),
                                n ? (e.cookieConsent.userConsent.acceptLevel("targeting", !1), e.cookieConsent.javascriptItems.enableScriptsByLevel("targeting")) : e.cookieConsent.userConsent.rejectLevel("targeting", !1),
                                o(!0);
                        }).then(function () {
                            e.cookieConsent.userConsent.saveCookie(),
                                e.cookieConsent.log("consentImplied loadInitialCookiesForNewUser: strictly-necessary (true), functionality (" + t + "), tracking (" + i + "), targeting (" + n + ")", "info");
                        });
                    }),
                    t
                );
            })(ae),
            re = (function (e) {
                function t(t) {
                    var i = e.call(this, t) || this;
                    return (i.cookieConsent = t), i;
                }
                return (
                    F(t, e),
                    (t.prototype.loadInitialCookiesForNewUser = function () {
                        var e = this;
                        e.cookieConsent.log("consentExpress loadInitialCookiesForNewUser triggered", "info");
                        var t = !1,
                            i = !1,
                            n = !1;
                        if (null !== e.cookieConsent.ownerPageLoadConsentLevels)
                            for (var o in e.cookieConsent.ownerPageLoadConsentLevels) {
                                var a = e.cookieConsent.ownerPageLoadConsentLevels[o];
                                "functionality" == a && (t = !0), "tracking" == a && (i = !0), "targeting" == a && (n = !0);
                            }
                        else (t = !1), (i = !1), (n = !1);
                        new Promise(function (o, a) {
                            e.cookieConsent.javascriptItems.enableScriptsByLevel("strictly-necessary"),
                                t ? (e.cookieConsent.userConsent.acceptLevel("functionality", !1), e.cookieConsent.javascriptItems.enableScriptsByLevel("functionality")) : e.cookieConsent.userConsent.rejectLevel("functionality", !1),
                                i ? (e.cookieConsent.userConsent.acceptLevel("tracking", !1), e.cookieConsent.javascriptItems.enableScriptsByLevel("tracking")) : e.cookieConsent.userConsent.rejectLevel("tracking", !1),
                                n ? (e.cookieConsent.userConsent.acceptLevel("targeting", !1), e.cookieConsent.javascriptItems.enableScriptsByLevel("targeting")) : e.cookieConsent.userConsent.rejectLevel("targeting", !1),
                                o(!0);
                        }).then(function () {
                            e.cookieConsent.userConsent.saveCookie(),
                                e.cookieConsent.log("consentExpress loadInitialCookiesForNewUser: strictly-necessary (true), functionality (" + t + "), tracking (" + i + "), targeting (" + n + ")", "info");
                        });
                    }),
                    t
                );
            })(ae),
            ce = (function () {
                function e(e) {
                    this.cookieConsent = e;
                }
                return (
                    (e.prototype.getClass = function () {
                        return "termsfeed-com---palette-light";
                    }),
                    e
                );
            })(),
            le = (function (e) {
                function t(t) {
                    var i = e.call(this, t) || this;
                    return (i.cookieConsent = t), i;
                }
                return (
                    F(t, e),
                    (t.prototype.getClass = function () {
                        return "termsfeed-com---palette-dark";
                    }),
                    t
                );
            })(ce),
            pe = (function (e) {
                function t(t) {
                    var i = e.call(this, t) || this;
                    return (i.cookieConsent = t), i;
                }
                return (
                    F(t, e),
                    (t.prototype.getClass = function () {
                        return "termsfeed-com---palette-light";
                    }),
                    t
                );
            })(ce),
            de = (function () {
                function e(e) {
                    (this.USER_TOKEN_COOKIE_NAME = "cookie_consent_user_consent_token"), (this.cookieConsent = e), this.initUserConsentToken();
                }
                return (
                    (e.prototype.initUserConsentToken = function () {
                        var e = V("ABCDEFGHIJKLMNOPQRSTUVWXYZ"),
                            t = V("abcdefghijklmnopqrstuvwxyz"),
                            i = V("0123456789"),
                            n = V(e, i, t);
                        (this.cookieConsent.userConsentToken =
                            a.getCookie(this.USER_TOKEN_COOKIE_NAME) ||
                            this.cookieConsent.configUserConsentToken ||
                            (function (e, t) {
                                return V(Array(t))
                                    .map(function (t) {
                                        return e[(Math.random() * e.length) | 0];
                                    })
                                    .join("");
                            })(n, 12)),
                            a.setCookie(this.USER_TOKEN_COOKIE_NAME, this.cookieConsent.userConsentToken, this.cookieConsent.ownerDomain, this.cookieConsent.cookieSecure, this.cookieConsent.cookieDuration);
                    }),
                    e
                );
            })(),
            ue = (function () {
                function e(e) {
                    switch (
                        ((this.forceCallbacksDispatching = !0),
                        (this.configUserConsentToken = void 0),
                        (this.userConsentToken = void 0),
                        (this.debug = !1),
                        (this.ownerConsentType = e.consent_type || "express"),
                        (this.ownerWebsiteName = e.website_name || ""),
                        (this.ownerWebsitePrivacyPolicyUrl = e.website_privacy_policy_url || null),
                        (this.ownerColorPalette = e.palette || "light"),
                        (this.ownerSiteLanguage = e.language || "en"),
                        (this.ownerDomain = e.cookie_domain || ""),
                        (this.ownerWebsiteImpressumUrl = e.website_impressum_url || null),
                        (this.noticeBannerInsertLegalUrls = e.notice_banner_insert_legal_urls || !1),
                        (this.cookieSecure = e.cookie_secure || !1),
                        (this.ownerPageLoadConsentLevels = e.page_load_consent_levels || null),
                        (this.ownerNoticeBannerType = e.notice_banner_type || "headline"),
                        (this.ownerNoticeBannerRejectButtonHide = e.notice_banner_reject_button_hide || !1),
                        (this.ownerNoticeBannerAppendContentPosition = e.notice_banner_append || "afterbegin"),
                        (this.ownerOpenPreferencesCenterSelector = e.open_preferences_center_selector || "#open_preferences_center"),
                        (this.ownerPreferencesCenterCloseButtonHide = e.preferences_center_close_button_hide || !1),
                        (this.pageRefreshConfirmationButtons = e.page_refresh_confirmation_buttons || !1),
                        (this.configUserConsentToken = e.user_consent_token || null),
                        (this.cookieDuration = parseInt(e.cookie_duration || 3650)),
                        (this.userDefinedNonce = a.getNonceFromScriptTag()),
                        (this.isDemo = "true" == e.demo),
                        (this.debug = "true" == e.debug),
                        this.ownerConsentType)
                    ) {
                        default:
                        case "express":
                            this.consentType = new re(this);
                            break;
                        case "implied":
                            (this.consentType = new se(this)), (this.userConsentTokenClass = new de(this));
                    }
                    switch (this.ownerColorPalette) {
                        default:
                        case "dark":
                            this.colorPalette = new le(this);
                            break;
                        case "light":
                            this.colorPalette = new pe(this);
                    }
                    switch (this.ownerNoticeBannerType) {
                        default:
                        case "simple":
                            this.noticeBannerContainer = new te(this);
                            break;
                        case "headline":
                            this.noticeBannerContainer = new ie(this);
                            break;
                        case "interstitial":
                            this.noticeBannerContainer = new ne(this);
                            break;
                        case "standalone":
                            this.noticeBannerContainer = new oe(this);
                    }
                    (this.events = new H()),
                        (this.eventsListeners = new Z(this)),
                        (this.customerCallbacks = new Y(this, e.callbacks)),
                        (this.forceCallbacksDispatching = e.callbacks_force || !1),
                        (this.i18n = new W(this)),
                        (this.cookieLevels = new Q(this)),
                        (this.userConsent = new $(this)),
                        (this.javascriptItems = new G(this)),
                        (this.preferencesCenterContainer = new X(this)),
                        null !== this.ownerOpenPreferencesCenterSelector && this.preferencesCenterContainer.listenToUserButtonToOpenPreferences(this.ownerOpenPreferencesCenterSelector),
                        !0 === this.userConsent.userAccepted
                            ? (this.userConsent.loadAcceptedCookies(), !0 === this.isDemo && this.noticeBannerContainer.initNoticeBanner())
                            : (this.noticeBannerContainer.initNoticeBanner(), this.consentType.loadInitialCookiesForNewUser());
                }
                return (
                    (e.prototype.log = function (e, t, i) {
                        if ((void 0 === i && (i = "log"), !0 === this.debug)) {
                            var n = new Date().toISOString();
                            console.log("[" + n + "][" + t + "] " + e);
                        }
                    }),
                    (e.prototype.openPreferencesCenter = function () {
                        this.preferencesCenterContainer.showPreferencesCenter();
                    }),
                    e
                );
            })(),
            _e = function (e) {
                return (
                    (o = new ue(e)),
                    (window.cookieconsent.openPreferencesCenter = function () {
                        o.openPreferencesCenter();
                    }),
                    o
                );
            };
    },
]);
